import React, { useState, useEffect } from 'react';
import newUserStyles from '../styles/newUserStyles';
import BodyContainer from '../ui/BodyContainer';
import SignupSkeleton from '../ui/signupSkeleton';
import CustomButton from '../ui/viewEventUi/CustomButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Services from '../services/services';
import Loader from '../ui/Loader';
import toast, { Toaster } from 'react-hot-toast';
import { isAlphabet, isInteger, isEmail } from '../regexFuncs';
import { groupIcon } from '../ui/icons';

const useStyles = makeStyles((theme) => newUserStyles(theme));

function NewUser() {
  const classes = useStyles();
  const history = useHistory();

  const [loader, setLoader] = React.useState(false);
  const [firstName, setFirstName] = useState({
    error: false,
    helpertext: null,
    value: '',
  });

  const [lastName, setLastName] = useState({
    error: false,
    helpertext: null,
    value: '',
  });

  const [email, setEmail] = useState({
    error: false,
    helpertext: null,
    value: '',
  });

  const [phone, setPhone] = useState({
    error: false,
    helpertext: null,
    value: '',
  });

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      createUser();
    }
  };

  const checkIsUser = async (emailId) => {
    try {
      const res = await Services.check_is_user(emailId);
      if (res.data?.responseCode === 302) {
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  };

  const onChangeFirstName = (e) => {
    const value = e.target.value;
    if (value === '' || (isAlphabet(value) && value.length <= 16)) {
      setFirstName({
        error: false,
        helpertext: null,
        value: value,
      });
    }
  };

  const onChangeLastName = (e) => {
    const value = e.target.value;
    if (value === '' || (isAlphabet(value) && value.length <= 16)) {
      setLastName({
        error: false,
        helpertext: null,
        value: value,
      });
    }
  };

  const onChangeEmail = async (e) => {
    const value = e.target.value;
    setEmail({
      error: false,
      helpertext: null,
      value: value,
    });
  };

  const onChangePhone = (value, country) => {
    setPhone({
      error: false,
      helpertext: null,
      value: value,
    });
  };

  const mailBlurHandle = async () => {
    if (isEmail(email.value)) {
      const isAlreadyUser = await checkIsUser(email.value);
      if (isAlreadyUser) {
        setEmail((prevState) => {
          return {
            ...prevState,
            error: true,
            helpertext: 'Email is already registered',
          };
        });
        return true;
      }
    }
  };

  const Validation_fun = () => {
    if (firstName.value === '') {
      setFirstName((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'First name is required',
        };
      });
    }
    if (lastName.value === '') {
      setLastName((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'Last name is required',
        };
      });
    }
    if (email.value === '') {
      setEmail((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'Email address is required',
        };
      });
    } else if (!isEmail(email.value)) {
      setEmail((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'Email address is not valid',
        };
      });
    } else {
      mailBlurHandle();
    }

    // if (phone.value === '') {
    //   setPhone((prevState) => {
    //     return {
    //       ...prevState,
    //       error: true,
    //       helpertext: 'Phone number is required',
    //     };
    //   });
    // } else if (phone.value?.length < 10) {
    //   setPhone((prevState) => {
    //     return {
    //       ...prevState,
    //       error: true,
    //       helpertext: 'Phone number is not valid',
    //     };
    //   });
    // }

    if (
      firstName.value === '' ||
      firstName.value === undefined ||
      firstName.value === null ||
      lastName.value === '' ||
      lastName.value === undefined ||
      lastName.value === null ||
      email.value === '' ||
      email.value === undefined ||
      email.value === null ||
      email.error ||
      !isEmail(email.value)
      // ||      phone.value.length < 10
    ) {
      return false;
    } else {
      return true;
    }
  };
  //create new user
  const createUser = () => {
    const okNoFor = 2;
    if (Validation_fun()) {
      let user_data = {
        firstName: firstName.value,
        lastName: lastName.value,
        email: email.value,
        password: null,
        // phone: phone.value,
        // phone: null,
        userType: okNoFor,
        // password: "castus", //change this later
      };
      setLoader(!loader);

      Services.create_user(user_data)
        .then((userResponse) => {
          if (userResponse.data.responseCode === 201) {
            setLoader(false);
            toast.success('Host created successfully', { duration: 4000 });
            history.push('/');
          } else {
            setLoader(false);
            toast.error(userResponse.data.details, { duration: 4000 });
          }
        })
        .catch((error) => {
          setLoader(false);
          toast.error('failed', { duration: 4000 });
        });
    }
  };
  return (
    <BodyContainer title="Create Host" icon={groupIcon()}>
      <Grid className={classes.gridOccupy}>
        <Paper elevation={0} className={classes.root}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <form className={classes.form}>
              <Grid container>
                <SignupSkeleton
                  fError={firstName.error}
                  fHelp={firstName.helpertext}
                  fValue={firstName.value}
                  changeFName={onChangeFirstName}
                  handleEnter={handleEnter}
                  inputStyles={classes.inputStyles}
                  LError={lastName.error}
                  LHelp={lastName.helpertext}
                  LValue={lastName.value}
                  changeLName={onChangeLastName}
                  EError={email.error}
                  EHelp={email.helpertext}
                  EValue={email.value}
                  changeEmail={onChangeEmail}
                  mailBlurHandle={mailBlurHandle}
                  PError={phone.error}
                  PHelp={phone.helpertext}
                  PValue={phone.value}
                  changePhone={onChangePhone}
                  isUserPage={false}
                  phoneErrorCls={classes.phoneErrorCls}
                  showPhoneInput={false}
                />
              </Grid>
              <div className={classes.btnDiv}>
                <CustomButton
                  btnStyle={classes.button1}
                  clickHandle={() => history.push('/')}
                  btnText={'Cancel'}
                />
                <CustomButton
                  btnStyle={classes.button}
                  clickHandle={createUser}
                  btnText={'Create Host'}
                />
              </div>
            </form>
          </Box>
        </Paper>
      </Grid>
      <Toaster position="top-center"></Toaster>
      <Loader open={loader} />
    </BodyContainer>
  );
}

export default NewUser;
